import { render, staticRenderFns } from "./client-health-information.vue?vue&type=template&id=5786c98f&"
import script from "./client-health-information.vue?vue&type=script&lang=js&"
export * from "./client-health-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports